'use strict';

exports.__esModule = true;
exports.default = getCurrentHref;

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentHref() {
  if (!_canUseDom2.default) {
    return 'http://www.facebook.com';
  }

  return location.href;
}
//# sourceMappingURL=getCurrentHref.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-facebook/lib/utils/getCurrentHref.js
// module id = 33
// module chunks = 95715928098905 172441821870073 232727283551173